export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Biowell';
export const VERSION = process.env.REACT_APP_VERSION || '1.0.0';

/** Matches PortaleHeader / Footer horizontal inset so page content aligns with the header. */
export const PORTAL_PAGE_CONTAINER_CLASS =
  'mx-auto w-full max-w-[1920px] px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-40';

/** Ex-VAT shipping and fulfilment fee (matches order invoice logic). */
export const SHIPPING_AND_FULFILMENT = 7.234;

export function readEnv(name, fallback) {
  const raw =
    typeof process !== 'undefined' && process.env
      ? process.env[name]
      : undefined;
  let value = raw;
  if (typeof value !== 'string' && typeof window !== 'undefined') {
    value = window.__ENV__ && window.__ENV__[name];
  }
  if (typeof value !== 'string') return fallback;
  let v = value.trim();
  if (
    (v.startsWith('"') && v.endsWith('"')) ||
    (v.startsWith("'") && v.endsWith("'"))
  ) {
    v = v.slice(1, -1).trim();
  }
  return v || fallback;
}

/**
 * Base URL of the marketing website app (separate codebase in website/,
 * served on port 3001 locally). Override via REACT_APP_WEBSITE_URL.
 */
export function getHomepageUrl() {
  const fallback =
    process.env.NODE_ENV === 'production'
      ? 'https://www.biowell.nl'
      : 'http://localhost:3001';
  return readEnv('REACT_APP_WEBSITE_URL', fallback);
}
